import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export function common() {
    window.addEventListener('DOMContentLoaded', () => {
        gsap.config({ nullTargetWarn: false });

        　　　　　// フッター TOPスクロールボタン
        let scrollTimeout;
        
        // ページ読み込み時にボタンを非表示にする
        window.addEventListener("DOMContentLoaded", () => {
            const scrollTopButton = document.getElementById("js-scrollTop");
            const ctaButton = document.getElementById("js-cta");
            
            // 最初は両方非表示にする
            gsap.set([scrollTopButton, ctaButton], {
                autoAlpha: 0,
            });
        });
        
        window.addEventListener("scroll", () => {
            if (!scrollTimeout) {
                scrollTimeout = requestAnimationFrame(() => {
                    const scrollTopButton = document.getElementById("js-scrollTop");
                    const ctaButton = document.getElementById("js-cta"); // js-cta 要素を取得
                    const isScrollingDown = window.scrollY > 100;
        
                    // js-scrollTop と js-cta を同時に表示・非表示
                    if ((isScrollingDown && gsap.getProperty(scrollTopButton, "opacity") === 0) ||
                        (!isScrollingDown && gsap.getProperty(scrollTopButton, "opacity") === 1)) {
                        gsap.to([scrollTopButton, ctaButton], { // 両方の要素を配列にして同時にアニメーション
                            duration: .5,
                            autoAlpha: isScrollingDown ? 1 : 0,
                            ease: isScrollingDown ? "power3.out" : "power3.in",
                        });
                    }
        
                    scrollTimeout = null;
                });
            }
        });
        

        document.getElementById("js-scrollTop").addEventListener("click", () => {
            gsap.to(window, {
                duration: .5,
                scrollTo: {
                    y: 0,
                    autoKill: false,
                },
            });
        });

//         // contact セクションが表示されたら js-cta を非表示にするための IntersectionObserver
// const contactSection = document.getElementById("contact");
// const ctaButton = document.getElementById("js-cta");

// const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//         if (entry.isIntersecting) {
//             // contact セクションが表示された場合 js-cta を非表示
//             gsap.to(ctaButton, {
//                 duration: .3,
//                 autoAlpha: 0,
//                 ease: "power3.in",
//             });
//         } else {
//             // contact セクションが見えなくなった場合 js-cta を再表示
//             gsap.to(ctaButton, {
//                 duration: .3,
//                 autoAlpha: 1,
//                 ease: "power3.out",
//             });
//         }
//     });
// }, { threshold: 0.1 }); // 10% 以上表示されたら判定

// observer.observe(contactSection);



        // 電話PC時は無効
        const ua = navigator.userAgent.toLowerCase();
        const isMobile = /iphone/.test(ua) || /android(.+)?mobile/.test(ua);

        if (!isMobile) {
            document.querySelectorAll('a[href^="tel:"]').forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                });
                link.classList.add('disabled-link');
                // cursor: default を追加
        link.style.cursor = 'default';
            });
        }
    });
}
